import { Flex, Text } from "@chakra-ui/react";
import {
    chakraComponents,
    OptionBase,
    Select as ReactSelect
} from "chakra-react-select";
import { Control, Controller } from "react-hook-form";
import { supportedCurrencyMappings } from "src/data/Countries";
import { Field } from "../ui/field";


interface CodeCurrency extends OptionBase {
    label: string;
    value: string;
}

// convert into code currency pairs and remove unwanted currencies
const codeCurrency = Object.keys(supportedCurrencyMappings).map(c => {
    let cc: CodeCurrency = {
        value: c,
        label: supportedCurrencyMappings[c]
    }
    return cc;
});

const customItem = (item: CodeCurrency) => (
    <Flex align="left">
        <Text fontWeight={'bold'}>{item.value}</Text>
        <Text ml="2px" fontSize='.8rem'>{item.label}</Text>
    </Flex>
);

const customOption = (props) => (
    <chakraComponents.Option label={props.data.name} {...props}>
        {customItem(props.data)}
    </chakraComponents.Option>
);

// with control support for forms
const CurrencySelectController = ({
    control, name, readOnly,
    label = 'Währung',
    placeholder = 'Währung auswählen',
    requiredMessage = 'Währung auswählen',
    currencyCodes,
    language = 'en',
    onValueChange,
    ...props
}: {
    control: Control<any, any>,
    name: string,
    readOnly: boolean,
    label?: string,
    placeholder?: string,
    requiredMessage?: string,
    currencyCodes?: string[],
    language?: string,
    onValueChange?: (value: string) => void,
    [key: string]: any
}) => {
    const displayNames = currencyCodes ? new Intl.DisplayNames([language], { type: 'currency' }) : undefined;
    const options = currencyCodes
        ? [...new Set(currencyCodes)].map(value => ({ value, label: displayNames?.of(value) ?? value }))
            .sort((a, b) => a.value.localeCompare(b.value))
        : codeCurrency;
    return (
        <Controller control={control} name={name}
            rules={{ required: requiredMessage, validate: (value) => value.length > 0 }}
            render={({ field: { value, name, onChange, onBlur, ref }, fieldState: { error } }) => (
                <Field id={name} label={label} required invalid={!!error} errorText={error?.message} disabled={readOnly}>
                    <CurrencySelectPlain value={value} name={name} ref={ref} onBlur={onBlur}
                        placeholder={placeholder} options={options}
                        onChange={value => { onValueChange?.(value); onChange(value); }} {...props} />
                </Field>
            )} />
    );
}

const CurrencySelectPlain = ({ value, onChange, options = codeCurrency, ...props }) => {
    return (
        <ReactSelect
            placeholder='Währung auswählen'
            options={options}
            onChange={val => { if (val) onChange(val.value); }}
            value={options.find(c => c.value === value)}
            components={{ Option: customOption }}
            formatOptionLabel={(option: CodeCurrency) => customItem(option)}
            getOptionLabel={(option: CodeCurrency) => option.label}
            getOptionValue={(option: CodeCurrency) => option.value}
            {...props}
        />
    );
}

export default CurrencySelectController
